import { useState } from "react";

import { S3ImageProps } from "./S3Image";
import { S3ImageFullScreen } from "./S3ImageFullScreen";
import VideoFullScreen from "./VideoFullScreen";
import { allowedFileTypes, getFileExtensionFromSignedUrl } from "./fileHelper";

interface MediaFullScreenProps {
  keyFrame?: string;
  mediaOutput?: string;
  s3ImageFullScreenProps?: Omit<S3ImageProps, "s3Key" | "onClickVideoIcon">;
  height?: number | string;
}

export const MediaFullScreen = ({
  keyFrame = "",
  mediaOutput = "",
  s3ImageFullScreenProps,
  height = 40,
}: MediaFullScreenProps) => {
  const [videoUrl, setVideoUrl] = useState("");

  const handleVideoUrl = (url: string) => () => {
    setVideoUrl(url);
  };

  const handleCloseVideo = () => {
    setVideoUrl("");
  };

  const mediaOutputExtension = getFileExtensionFromSignedUrl(mediaOutput);

  const isVideo = allowedFileTypes.videos.some(
    (allowedVideoExtension): boolean => {
      return allowedVideoExtension === mediaOutputExtension;
    }
  );

  return (
    <>
      {!!videoUrl && (
        <VideoFullScreen
          signedUrl={videoUrl}
          open={!!videoUrl}
          onClose={handleCloseVideo}
        />
      )}
      <S3ImageFullScreen
        {...s3ImageFullScreenProps}
        sx={{
          width: "100%",
          maxHeight: height,
          maxWidth: "120px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
        s3Key={keyFrame}
        onClickVideoIcon={
          mediaOutput && isVideo ? handleVideoUrl(mediaOutput) : undefined
        }
      />
    </>
  );
};
